import React from 'react'
import clsx from 'clsx'
import { Fade, Menu, MenuItem } from '@mui/material'

import useStyles from './styles'

const defaultClasses = {
  paper: '',
  list: '',
  item: '',
  title: '',
  disabledItem: '',
  icon: ''
}

const ButtonMenu = ({
  title,
  options,
  onSelect,
  renderOption,
  disabled = false,
  children,
  className,
  menuProps = {},
  selected = '',
  classes: extraClasses = defaultClasses,
  smallIcons = false
}) => {
  const [anchor, setAnchor] = React.useState(null)
  const isOpen = React.useMemo(() => Boolean(anchor), [anchor])
  const classes = useStyles({ disabled, smallIcons })

  const handleOpen = React.useCallback(
    e => {
      e.stopPropagation()

      if (disabled) {
        return
      }

      setAnchor(e.currentTarget)
    },
    [disabled]
  )

  const handleClose = React.useCallback(e => {
    e.stopPropagation()
    setAnchor(null)
  }, [])

  return (
    <>
      <div className={clsx(classes.root, className)} onClick={handleOpen}>
        {children}
      </div>

      {isOpen && (
        <Menu
          elevation={3}
          getContentAnchorEl={null}
          anchorEl={anchor}
          open={isOpen}
          onClose={handleClose}
          TransitionComponent={Fade}
          keepMounted
          classes={{
            paper: clsx(classes.menu, extraClasses.paper),
            list: clsx(classes.list, extraClasses.list)
          }}
          onClick={e => e.stopPropagation()}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          {...menuProps}
        >
          {title && (
            <div
              className={clsx(classes.item, classes.title, extraClasses.title)}
            >
              {title}
            </div>
          )}

          {options.map(option => {
            let name = ''
            let Icon = null
            let disabled = false

            if (typeof option === 'object') {
              name = option.name
              Icon = option.Icon
              disabled = option.disabled
            } else {
              name = option
            }

            return (
              <MenuItem
                key={name}
                onClick={e => {
                  e.stopPropagation()
                  setAnchor(null)
                  !disabled && onSelect && onSelect(name)
                }}
                disabled={disabled}
                disableGutters
                classes={{
                  root: clsx(
                    clsx(classes.item, extraClasses.item),
                    disabled &&
                      clsx(classes.disabledItem, extraClasses.disabledItem)
                  )
                }}
                selected={
                  typeof selected === 'string' ? selected === name : false
                }
              >
                {Icon && (
                  <Icon
                    fill={disabled ? '#8F8F8F' : undefined}
                    className={clsx(classes.icon, extraClasses.icon)}
                  />
                )}

                {renderOption ? renderOption(name) : name}
              </MenuItem>
            )
          })}
        </Menu>
      )}
    </>
  )
}

export default ButtonMenu
